export default __webpack_public_path__ + "static/media/logo.1047b102.svg";